import ActionTypes from '../../../../constants/ActionTypes';

const INITIAL_STATE = {
	byParentFeatureKey: {},
};

const add = (state, place, features) => {
	if (place && features) {
		return {
			...state,
			byParentFeatureKey: {
				...state.byParentFeatureKey,
				[place]: features,
			},
		};
	} else {
		return state;
	}
};

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case ActionTypes.WORLD_WATER.STATISTICS.FEATURES.ADD:
			return add(state, action.place, action.features);
		default:
			return state;
	}
};
